import { formatResultDuration } from './result-duration';
// API times represent race durations: compare the clock part, not the calendar date.
export function parseResultTime(value) {
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/(?:^|[T ])(\d{1,3}):([0-5]\d):([0-5]\d)(?:[.,](\d{1,6}))?(?:Z|[+-]\d{2}:?\d{2})?$/);
  if (!match) return null;
  const milliseconds = (Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3])) * 1000
    + Number(((match[4] || '') + '000').slice(0, 3));
  if (milliseconds === 0) return null;
  return { milliseconds, text: formatResultDuration(milliseconds) };
}

function isMissingTime(value) {
  return value === null || value === undefined || String(value).trim() === ''
    || String(value).trim() === '0'
    || /(?:^|[T ])00:00:00(?:[.,]0+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(String(value).trim());
}

export function backupDifferencePriority(row) {
  if (row.missing) return 3;
  if (row.missingBackup) return 1;
  return 2;
}

export function sortBackupDifferences(rows) {
  return rows.slice().sort((a, b) => backupDifferencePriority(b) - backupDifferencePriority(a)
    || b.difference - a.difference || a.key - b.key);
}

export default function getBackupDifferences(results) {
  if (!Array.isArray(results)) return [];
  return results.map((row, index) => {
    const normalized = {};
    Object.keys(row || {}).forEach(key => { normalized[key.toLowerCase()] = row[key]; });
    const backup = parseResultTime(normalized.uploaded_time);
    if (!backup && !isMissingTime(normalized.uploaded_time)) return null;
    const rawTime = normalized.registered_time;
    // DNS/DSQ/DNF are explicit statuses, not forgotten arrivals.
    if (/^(DNS|DSQ|DNF)$/i.test(String(rawTime || '').trim())) return null;
    const time = parseResultTime(rawTime);
    if (!time && !isMissingTime(rawTime)) return null;
    if (!time && !backup) return null;
    if (time && backup && Math.abs(time.milliseconds - backup.milliseconds) <= 2000) return null;
    return {
      key: index,
      number: normalized.bib,
      userID: normalized.id,
      distanceID: normalized.distance_id,
      distance: normalized.distance,
      time: time ? time.text : 'No',
      backup: backup ? backup.text : 'No',
      missingBackup: !backup,
      missing: !time,
      difference: time && backup ? Math.abs(time.milliseconds - backup.milliseconds) : Infinity
    };
  }).filter(Boolean).sort((a, b) => Number(b.missing || b.missingBackup) - Number(a.missing || a.missingBackup)
    || b.difference - a.difference || a.key - b.key);
}



// WEBPACK FOOTER //
// ./src/utils/backup-differences.js